'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTimeline = function MdTimeline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38.4 13.4c0 1.8-1.6 3.2-3.4 3.2-0.3 0-0.6 0-0.9 0l-5.9 5.9c0.1 0.2 0.2 0.6 0.2 0.9 0 1.8-1.6 3.2-3.4 3.2s-3.4-1.4-3.4-3.2c0-0.4 0.1-0.7 0.2-0.9l-4.3-4.3c-0.2 0.1-0.6 0.2-0.9 0.2s-0.6-0.1-0.8-0.2l-7.6 7.6c0.1 0.2 0.2 0.5 0.2 0.8 0 1.8-1.6 3.4-3.4 3.4s-3.4-1.6-3.4-3.4 1.6-3.2 3.4-3.2c0.3 0 0.6 0 0.9 0l7.5-7.5c0-0.3 0-0.6 0-0.9 0-1.8 1.4-3.4 3.2-3.4s3.4 1.6 3.4 3.4c0 0.3 0 0.6-0.1 0.9l4.2 4.2c0.3-0.1 0.6-0.1 0.9-0.1s0.6 0 0.9 0.1l5.9-5.9c-0.1-0.2-0.2-0.5-0.2-0.8 0-1.8 1.6-3.4 3.4-3.4s3.4 1.6 3.4 3.4z' })
        )
    );
};

exports.default = MdTimeline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/timeline.js
// module id = 1998
// module chunks = 168707334958949